import { BlockWrapper, smartProps, defineBlock, useInspectorControl, ChildrenBlock } from '@smartfire/js-block-engine';
import { EditableHeading, EditableText } from '@smartfire/components';
import Inspector from './inspector';
import clsx from 'clsx';
import style from './block.module.scss';

const TwoColumns = ({ reverseMobile, largeGap, isContentWidth }) => {
    useInspectorControl(Inspector);

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={clsx(style.content, isContentWidth && style.contentWidth)}>
                <EditableText tagName="p" className={style.subtitle} smartProp="subtitle" placeholder="Sous-titre..." />
                <EditableHeading className={style.title} smartProp="title" placeholder="Titre..." />
                <ChildrenBlock
                    key="children"
                    gutenbergEditorConfig={{
                        orientation: 'horizontal',
                        allowedBlocks: ['smartfire/two-columns---column'],
                        template: [
                            ['smartfire/two-columns---column', {}],
                            ['smartfire/two-columns---column', {}],
                        ],
                    }}
                    className={clsx(style.columns, largeGap && style.largeGap, reverseMobile && style.reverseMobile)}
                />
            </div>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: TwoColumns,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 2,
            content: '',
        }),
        subtitle: smartProps.string.withDefault(''),
        largeGap: smartProps.bool.withDefault(false),
        reverseMobile: smartProps.bool.withDefault(false),
        isContentWidth: smartProps.bool.withDefault(true),
    },
    setup: {
        title: 'Deux colonnes',
    },
});
